import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { setMeta } from "../lib/meta";

const SITE = "Probably True";

export default function TitleManager() {
  const { pathname } = useLocation();
  const { t, lang } = useLanguage();

  useEffect(() => {
    // Article detail pages manage their own title + meta.
    if (/^\/wiki\/[^/]+$/.test(pathname)) return;

    const map = {
      "/": t("title.home"),
      "/wiki": t("title.wiki"),
      "/hall-of-fame": t("title.hof"),
      "/hall-of-shame": t("title.hos"),
      "/login": t("title.login"),
      "/register": t("title.register"),
      "/credits": t("title.credits"),
      "/credits/success": t("title.payment"),
      "/my-bets": t("title.mybets"),
      "/settings": t("title.settings"),
      "/admin": t("title.admin"),
    };

    const label = map[pathname];
    document.title = label ? `${label} — ${SITE}` : SITE;
    setMeta({ title: label });
  }, [pathname, t, lang]);

  return null;
}
